import { CheckoutToolStepTrackingInfo } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsToolGenericInfo {
    name: string;
    type: string;
    stepnumber: number;
    stepname: string;
    placement: string;

    result?: any;
    option?: string;
}

export interface GoogleAnalyticsToolStep extends GoogleAnalyticsMinimumDataset {
    info: GoogleAnalyticsToolGenericInfo;
}

const getGoogleAnalyticsToolStepSubmit = (
    data: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo>
): GoogleAnalyticsToolStep => {
    return getGoogleAnalyticsToolStep(data, GoogleAnalyticsEvents.ToolStepLast);
};

const getGoogleAnalyticsToolStep = (
    data: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo>,
    event: string = GoogleAnalyticsEvents.ToolStep
): GoogleAnalyticsToolStep => {
    return {
        event: event,
        info: {
            name: data.payload.eventData.name,
            type: data.payload.eventData.type,
            placement: data.payload.eventData.placement,
            stepname: data.payload.eventData.stepName,
            stepnumber: data.payload.eventData.stepNumber,
            option: data.payload.eventData.option,
            result: data.payload.eventData.result
        },
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data)
    };
};

export { getGoogleAnalyticsToolStep, getGoogleAnalyticsToolStepSubmit };
